(ns hai.mini-apps.edit
  "Mini-app edit page"
  #?(:cljs (:require-macros hai.mini-apps.edit))
  #?(:cljs
     (:require
      [hai.entity.helpers :as entity]
      [hai.sharing.components :as sharing.components]
      [hai.sharing.helper :as sharing]
      [hai.mini-apps.common :as common]
      [hai.ui.components :as c]
      [hai.ui.components.form.core :as form]
      [hai.ui.components.form.input :as input]
      [hai.ui.components.spinners :as spinners]
      [hai.ui.icons :as icons]
      [hai.ui.rf-sugar :refer [<s >e defevent-fx defsub]]
      [hai.ui.tokens :as t]
      [hai.ui.components.new-design.utils :refer [px->rem]]
      [hai.web-app.layout :as layout]
      [hai.web-app.routing :as routing]
      [lambdaisland.ornament :as o])
     :clj
     (:require
      [hai.ui.components.new-design.utils :refer [px->rem]]
      [hai.ui.tokens :as t]
      [lambdaisland.ornament :as o])))

;; ---------------------------------------------------------------------------
;; Styled components — header
;; ---------------------------------------------------------------------------

(o/defstyled icon-container :div
  :flex :items-center :justify-center :rounded-xl
  {:width (px->rem 56)
   :height (px->rem 56)
   :background-color t/--mood-color
   :flex-shrink "0"}
  [:svg {:width (px->rem 28)
         :height (px->rem 28)
         :fill t/--hai-dark-purple}])

(o/defstyled header-top :div
  :flex :items-center
  {:gap (px->rem 16)
   :margin-bottom (px->rem 8)})

(o/defstyled title-text :h1
  {:font-size (px->rem 28)
   :font-weight "700"
   :color t/--hai-dark-purple
   :margin "0"})

(o/defstyled description-text :p
  {:font-size (px->rem 15)
   :color t/--hai-grey-1
   :margin (str (px->rem 4) " 0 0 0")})

(o/defstyled meta-row :div
  :flex :items-center
  {:gap (px->rem 16)
   :margin-top (px->rem 12)})

(o/defstyled active-toggle :div
  :flex :items-center
  {:gap (px->rem 8)}
  [:.label {:font-size (px->rem 14)
            :font-weight "600"
            :color t/--hai-grey-1}])

(o/defstyled page-header :div
  {:margin-bottom (px->rem 16)})

;; ---------------------------------------------------------------------------
;; Styled components — connection section
;; ---------------------------------------------------------------------------

(o/defstyled section-card :div
  {:border (str "1px solid " t/--text-secondary-20)
   :border-radius (px->rem 12)
   :padding (px->rem 24)})

(o/defstyled section-label :span
  {:text-transform "uppercase"
   :font-weight "700"
   :font-size (px->rem 12)
   :color t/--hai-dark-purple
   :letter-spacing "0.05em"})

(o/defstyled section-title :h2
  {:font-size (px->rem 22)
   :font-weight "700"
   :color t/--hai-dark-purple
   :margin (str (px->rem 4) " 0 " (px->rem 4) " 0")})

(o/defstyled section-description :p
  {:font-size (px->rem 14)
   :color t/--hai-grey-1
   :margin (str "0 0 " (px->rem 16) " 0")})

(o/defstyled connection-row :div
  :flex :items-center
  {:gap (px->rem 12)
   :margin-bottom (px->rem 20)})

(o/defstyled manage-link :a
  {:color t/--hai-dark-purple
   :font-weight "600"
   :font-size (px->rem 14)
   :text-decoration "none"
   :cursor "pointer"}
  [:&:hover {:text-decoration "underline"}])

(o/defstyled field-label :label
  {:font-size (px->rem 14)
   :font-weight "600"
   :color t/--hai-black-1
   :margin-bottom (px->rem 6)
   :display "block"})

(o/defstyled field-hint :p
  {:font-size (px->rem 13)
   :color t/--hai-grey-1
   :margin (str (px->rem 4) " 0 0 0")})

;; ---------------------------------------------------------------------------
;; Styled components — match settings section
;; ---------------------------------------------------------------------------

(o/defstyled info-callout :div
  :flex :items-center
  {:gap (px->rem 10)
   :padding (str (px->rem 14) " " (px->rem 16))
   :background-color t/--hai-white-2
   :border-radius (px->rem 10)
   :margin-bottom (px->rem 20)}
  [:svg {:width (px->rem 20)
         :height (px->rem 20)
         :fill t/--hai-grey-1
         :flex-shrink "0"}]
  [:.text {:font-size (px->rem 14)
           :color t/--hai-grey-1
           :line-height "1.5"}])

(o/defstyled match-chip :div
  :inline-flex :items-center
  {:gap (px->rem 6)
   :padding (str (px->rem 6) " " (px->rem 12))
   :background-color "rgba(139, 92, 246, 0.1)"
   :border-radius (px->rem 20)
   :font-size (px->rem 14)
   :font-weight "600"
   :color t/--hai-dark-purple}
  [:button
   :flex :items-center :justify-center
   {:background "none"
    :border "none"
    :cursor "pointer"
    :padding "0"
    :line-height "1"}
   [:svg {:width (px->rem 16)
          :height (px->rem 16)
          :fill t/--hai-dark-purple}]]
  [:button:hover
   {:opacity "0.7"}])

(o/defstyled match-chips-row :div
  :flex :flex-wrap :items-center
  {:gap (px->rem 8)
   :margin-bottom (px->rem 12)})

(o/defstyled dashed-select-wrapper :div
  {:margin-bottom (px->rem 8)}
  [:>.rt-SelectTrigger
   {:border-style "dashed !important"}])

;; ---------------------------------------------------------------------------
;; Styled components — danger zone
;; ---------------------------------------------------------------------------

(o/defstyled danger-zone-card :div
  {:border "1px solid rgba(220, 38, 38, 0.3)"
   :border-radius (px->rem 12)
   :padding (px->rem 24)
   :background-color "rgba(220, 38, 38, 0.03)"})

(o/defstyled danger-zone-header :div
  :flex :items-center :justify-between
  [:.left :flex-1]
  [:.action {:flex-shrink "0"}])

(o/defstyled danger-label :span
  {:text-transform "uppercase"
   :font-weight "700"
   :font-size (px->rem 12)
   :color "rgb(220, 38, 38)"
   :letter-spacing "0.05em"})

(o/defstyled danger-link :a
  {:color "rgb(220, 38, 38)"
   :font-weight "600"
   :font-size (px->rem 14)
   :text-decoration "underline"
   :cursor "pointer"}
  [:&:hover {:opacity "0.8"}])

;; ---------------------------------------------------------------------------
;; Events
;; ---------------------------------------------------------------------------

#?(:cljs
   (defevent-fx ::load-connections
     [_ _]
     {:resolve {:query [{:user/connections
                         [:connection/uuid :connection/description :connection/type]}]
                :store-in [::connections]}}))

#?(:cljs
   (defevent-fx ::on-entity-loaded
     [{:keys [db]} mini-app-uuid]
     (let [mini-app (get-in db (entity/->ident {:mini-app/uuid mini-app-uuid}))
           tool (:mini-app/tool mini-app)
           conn-uuid (:connection/uuid (:mini-app/connection mini-app))]
       (when conn-uuid
         {:dispatch [::load-tables {:tool tool :connection-uuid conn-uuid}]}))))

(def ^:private mini-app-connection-types
  #{:airtable :notion :hubspot :jdbc :database})

#?(:cljs
   (defsub ::connections
     [db]
     (->> (get-in db [::connections :user/connections])
          (filter #(contains? mini-app-connection-types (:connection/type %))))))

;; HubSpot has fixed entity types with keyword IDs matching the browser extension
(def ^:private hubspot-deal-fields
  [{:id :hubspot.deal/name :name "Deal Name" :type "string"}
   {:id :hubspot.deal/stage-label :name "Stage" :type "string"}
   {:id :hubspot.deal/amount :name "Deal Amount" :type "number"}
   {:id :hubspot.deal/close-date :name "Close Date" :type "date"}
   {:id :hubspot.deal/company-name :name "Company Name" :type "string"}])

(def ^:private hubspot-contact-fields
  [{:id :hubspot.contact/firstname :name "First Name" :type "string"}
   {:id :hubspot.contact/lastname :name "Last Name" :type "string"}
   {:id :hubspot.contact/company :name "Company Name" :type "string"}
   {:id :hubspot.contact/email :name "Email" :type "string"}])

(def ^:private hubspot-default-selected-fields
  "Default selected fields matching browser extension's all-keys-set.
   Only core deal and contact fields, not custom contact properties."
  (into #{:hubspot/deal :hubspot/contact}
        (map :id)
        (concat hubspot-deal-fields hubspot-contact-fields)))

#?(:cljs
   (defevent-fx ::load-tables
     [{:keys [_db]} {:keys [tool connection-uuid]}]
     (let [query (case tool
                   :airtable [{:airtable/bases
                               [:airtable.base/id
                                :airtable.base/name
                                {:airtable.base/tables
                                 [:airtable.table/id
                                  :airtable.table/name
                                  {:airtable.table/fields
                                   [:airtable.field/id
                                    :airtable.field/name
                                    :airtable.field/type]}]}]}]
                   :notion [{:notion/databases
                             [:notion.page/id
                              :notion.page/title
                              :notion.page/url
                              :notion.database/id
                              {:notion.database/properties
                               [:notion.property/id
                                :notion.property/name
                                :notion.property/type]}]}]
                   (:jdbc :database) [:jdbc/tables]
                   nil)]
       (cond
         query
         {:fetch {:url "/resolve"
                  :method :post
                  :body {:query query
                         :options {:connection/uuid connection-uuid}}
                  :request-id [::tables connection-uuid]
                  :store-in [::tables connection-uuid]}}

         ;; HubSpot: fetch portal-id and contact properties, store static fields
         (= tool :hubspot)
         {:fx [[:dispatch [::load-hubspot-data connection-uuid]]]}))))

#?(:cljs
   (defevent-fx ::load-hubspot-data
     [{:keys [_db]} connection-uuid]
     {:fetch {:url "/resolve"
              :method :post
              :body {:query [:hubspot/portal-id :hubspot.contact/properties]
                     :options {:connection/uuid connection-uuid}}
              :request-id [::tables connection-uuid]
              :on-success-fx
              [[:dispatch [::on-hubspot-data-loaded connection-uuid '?body]]]}}))

#?(:cljs
   (defevent-fx ::on-hubspot-data-loaded
     [{:keys [db]} connection-uuid data]
     (let [contact-properties (:hubspot.contact/properties data)
           contact-fields (into hubspot-contact-fields
                                (for [{:hubspot.property/keys [key label custom?]} contact-properties
                                      :when (not (some #(= (:id %) key) hubspot-contact-fields))]
                                  {:id key
                                   :name (str (when custom? "[Custom] ") label)
                                   :type "string"}))]
       {:db (assoc-in db [::tables connection-uuid]
                      {:hubspot/portal-id (:hubspot/portal-id data)
                       :hubspot/contact-properties contact-properties
                       :hubspot/fields {:deals hubspot-deal-fields
                                        :contacts contact-fields}})})))

#?(:cljs
   (defsub ::tables
     [db connection-uuid]
     (get-in db [::tables connection-uuid])))

;; ---------------------------------------------------------------------------
;; Toggle handler
;; ---------------------------------------------------------------------------

#?(:cljs
   (defn toggle-active!
     [mini-app new-value]
     (let [uuid (:mini-app/uuid mini-app)]
       (>e [:resolve [(list 'mini-app/update
                            {:mini-app/uuid uuid
                             :mini-app/fields-update {:mini-app/active? new-value}})]
            {:on-success-fx [[:dispatch [:entity/resolve {:mini-app/uuid uuid}]]
                             [:browser-ext/notify-mini-apps-changed {:mini-app/uuids [uuid] :change :updated}]]}]))))

;; ---------------------------------------------------------------------------
;; Connection helpers
;; ---------------------------------------------------------------------------

#?(:cljs
   (defn current-table-value
     "Extracts a string key for the currently selected table from tool + config."
     [tool config]
     (case tool
       :airtable (let [base-id (:airtable/base-id config)
                       table-id (:airtable/table-id config)]
                   (when (and base-id table-id)
                     (str base-id "/" table-id)))
       :notion (get-in config [:notion/database :notion.page/id])
       (:jdbc :database)
       (let [schema (:blocks.jdbc/schema config)
             table (:blocks.jdbc/table config)]
         (when (and schema table)
           (str schema "/" table)))
       nil)))

#?(:cljs
   (defn table-options
     "Builds table options for the dropdown from loaded table data.
      Each option has :value (string for Radix Select), :label, and :data (original IDs)."
     [tool tables-data]
     (case tool
       :airtable
       (for [{base-id :airtable.base/id
              base-name :airtable.base/name
              tables :airtable.base/tables} (:airtable/bases tables-data)
             {table-id :airtable.table/id
              table-name :airtable.table/name} tables]
         {:value (str base-id "/" table-id)
          :label (str base-name " — " table-name)
          :data {:base-id base-id :table-id table-id}})

       :notion
       (for [{:notion.page/keys [id title]} (:notion/databases tables-data)]
         {:value id
          :label (or title "<Untitled>")
          :data {:database-id id}})

       (:jdbc :database)
       (for [{:jdbc/keys [schema table]} (:jdbc/tables tables-data)]
         {:value (str schema "/" table)
          :label (str schema "/" table)
          :data {:schema schema :table table}})

       nil)))

;; ---------------------------------------------------------------------------
;; Match-field helpers
;; ---------------------------------------------------------------------------

#?(:cljs
   (defn- airtable-read-only-types
     "Airtable field types that cannot be used for matching."
     [field-type]
     (contains? #{"date" "dateTime" "createdTime" "createdBy" "count"
                  "autoNumber" "lastModifiedBy" "lastModifiedTime"
                  "multipleRecordLinks"}
                field-type)))

#?(:cljs
   (defn available-fields
     "Returns available fields/properties for the currently selected table.
      Each field has :id, :name, :type keys."
     [tool tables-data config]
     (case tool
       :airtable
       (let [base-id (:airtable/base-id config)
             table-id (:airtable/table-id config)]
         (when (and base-id table-id)
           (->> (:airtable/bases tables-data)
                (some #(when (= (:airtable.base/id %) base-id) %))
                :airtable.base/tables
                (some #(when (= (:airtable.table/id %) table-id) %))
                :airtable.table/fields
                (remove #(airtable-read-only-types (:airtable.field/type %)))
                (mapv (fn [{:airtable.field/keys [id name type]}]
                        {:id id :name name :type type})))))

       :notion
       (let [database-id (get-in config [:notion/database :notion.page/id])]
         (when database-id
           (->> (:notion/databases tables-data)
                (some #(when (= (:notion.page/id %) database-id) %))
                :notion.database/properties
                (mapv (fn [{:notion.property/keys [id name type]}]
                        {:id id :name name :type type})))))

       :hubspot
       (when-let [fields (:hubspot/fields tables-data)]
         (into (:deals fields) (:contacts fields)))

       (:jdbc :database)
       (let [schema (:blocks.jdbc/schema config)
             table (:blocks.jdbc/table config)]
         (when (and schema table)
           (->> (:jdbc/tables tables-data)
                (some #(when (and (= (:jdbc/schema %) schema)
                                  (= (:jdbc/table %) table)) %))
                :jdbc/columns
                (mapv (fn [{:jdbc/keys [column type]}]
                        {:id column :name column :type type})))))

       nil)))

#?(:cljs
   (defn- current-match-fields
     "Returns the currently selected match fields from config as a vector of
      {:id :name :type} maps."
     [tool config]
     (case tool
       :airtable
       (mapv (fn [{:airtable.field/keys [id name type]}]
               {:id id :name name :type type})
             (:airtable/match-fields config))

       :notion
       (mapv (fn [{:notion.property/keys [id name type]}]
               {:id id :name name :type type})
             (:notion/match-properties config))

       :hubspot
       (vec (:hubspot/match-fields config))

       (:jdbc :database)
       (if-let [col (:blocks.jdbc/match-column config)]
         [{:id col :name col :type "string"}]
         [])

       [])))

#?(:cljs
   (defn- add-match-field
     "Returns updated config with the given field added to match fields."
     [tool config field]
     (case tool
       :airtable
       (update config :airtable/match-fields (fnil conj [])
               {:airtable.field/id (:id field)
                :airtable.field/name (:name field)
                :airtable.field/type (:type field)})

       :notion
       (update config :notion/match-properties (fnil conj [])
               {:notion.property/id (:id field)
                :notion.property/name (:name field)
                :notion.property/type (:type field)})

       :hubspot
       (update config :hubspot/match-fields (fnil conj []) field)

       ;; JDBC only supports a single match column
       (:jdbc :database)
       (assoc config :blocks.jdbc/match-column (:id field))

       config)))

#?(:cljs
   (defn- remove-match-field
     "Returns updated config with the given field-id removed from match fields."
     [tool config field-id]
     (case tool
       :airtable
       (update config :airtable/match-fields
               (fn [fields] (vec (remove #(= (:airtable.field/id %) field-id) fields))))

       :notion
       (update config :notion/match-properties
               (fn [props] (vec (remove #(= (:notion.property/id %) field-id) props))))

       :hubspot
       (update config :hubspot/match-fields
               (fn [fields] (vec (remove #(= (:id %) field-id) fields))))

       (:jdbc :database)
       (dissoc config :blocks.jdbc/match-column)

       config)))

;; ---------------------------------------------------------------------------
;; Field-visibility helpers
;; ---------------------------------------------------------------------------

#?(:cljs
   (defn- set-selected-fields
     "Returns updated config with selected fields set to the given visible-ids."
     [tool config all-fields visible-ids]
     (let [visible (filterv #(contains? visible-ids (:id %)) all-fields)]
       (case tool
         :airtable
         (assoc config :airtable/selected-fields
                (mapv (fn [{:keys [id name type]}]
                        {:airtable.field/id id
                         :airtable.field/name name
                         :airtable.field/type type})
                      visible))

         :notion
         (assoc config :notion/selected-properties
                (mapv (fn [{:keys [id name type]}]
                        {:notion.property/id id
                         :notion.property/name name
                         :notion.property/type type})
                      visible))

         :hubspot
         (assoc config :hubspot/selected-fields visible-ids)

         (:jdbc :database)
         (assoc config :blocks.jdbc/display-columns visible-ids)

         config))))

#?(:cljs
   (defn- selected-field-ids
     "Returns the set of currently visible field IDs.
      Empty selected-fields in config means all are visible."
     [tool config all-fields]
     (let [ids (case tool
                 :airtable (map :airtable.field/id (:airtable/selected-fields config))
                 :notion (map :notion.property/id (:notion/selected-properties config))
                 :hubspot (:hubspot/selected-fields config)
                 (:jdbc :database) (:blocks.jdbc/display-columns config)
                 nil)]
       (if (seq ids)
         (set ids)
         (if (= tool :hubspot)
           hubspot-default-selected-fields
           (set (map :id all-fields)))))))

#?(:cljs
   (defn- ensure-selected-fields
     "If selected-fields are missing from config, populates them with all available fields.
      Prevents the platform from filtering out all data when selected-fields is nil."
     [tool tables-data config]
     (let [all-fields (available-fields tool tables-data config)]
       (if (and (seq all-fields)
                (nil? (case tool
                        :airtable (:airtable/selected-fields config)
                        :notion (:notion/selected-properties config)
                        :hubspot (:hubspot/selected-fields config)
                        (:jdbc :database) (:blocks.jdbc/display-columns config)
                        nil)))
         (let [default-ids (if (= tool :hubspot)
                             hubspot-default-selected-fields
                             (set (map :id all-fields)))]
           (set-selected-fields tool config all-fields default-ids))
         config))))

;; ---------------------------------------------------------------------------
;; Header
;; ---------------------------------------------------------------------------

#?(:cljs
   (defn mini-app-header
     [mini-app]
     [page-header
      [header-top
       [icon-container [icons/outlined-apps]]
       [title-text (:mini-app/title mini-app)]]
      (when-let [description (:mini-app/description mini-app)]
        [description-text description])
      [meta-row
       [active-toggle
        [c/Switch {:checked (boolean (:mini-app/active? mini-app))
                   :on-checked-change #(toggle-active! mini-app %)}]
        [:span.label (if (:mini-app/active? mini-app) "Active" "Inactive")]]]]))

;; ---------------------------------------------------------------------------
;; Connection section
;; ---------------------------------------------------------------------------

#?(:cljs
   (defn- find-connection
     "Finds a connection by UUID string from the connections list."
     [connections uuid-str]
     (some #(when (= (str (:connection/uuid %)) uuid-str) %)
           connections)))

#?(:cljs
   (defn- on-connection-change
     [{:keys [connections set-connection! set-config!]}]
     (fn [uuid-str]
       (when-let [conn (find-connection connections uuid-str)]
         (set-connection! conn)
         (set-config! {})
         (>e [::load-tables {:tool (:connection/type conn)
                             :connection-uuid (:connection/uuid conn)}])))))

#?(:cljs
   (defn- on-table-change
     [{:keys [tool set-config! options-by-value tables-data]}]
     (fn [selected-value]
       (when-let [{:keys [data]} (get options-by-value selected-value)]
         (let [config (case tool
                        :airtable {:airtable/base-id (:base-id data)
                                   :airtable/table-id (:table-id data)
                                   :airtable/url (str "https://airtable.com/" (:base-id data) "/" (:table-id data))}
                        :notion (let [database (->> (:notion/databases tables-data)
                                                    (some #(when (= (:notion.page/id %) (:database-id data)) %)))]
                                  {:notion/database database})
                        (:jdbc :database) {:blocks.jdbc/schema (:schema data)
                                           :blocks.jdbc/table (:table data)}
                        {})]
           (set-config! (ensure-selected-fields tool tables-data config)))))))

#?(:cljs
   (defn connection-section
     [mini-app {:keys [connection-field config-field]}]
     (let [connections @(<s [::connections])
           current-conn (:form.field/current-value connection-field)
           set-connection! (:form.field/set-value! connection-field)
           set-config! (:form.field/set-value! config-field)
           tool (or (:connection/type current-conn) (:mini-app/tool mini-app))
           conn-uuid (:connection/uuid current-conn)
           tables-data @(<s [::tables conn-uuid])
           tables-loading? (= :start @(<s [:fetch/state [::tables conn-uuid]]))
           options (table-options tool tables-data)
           options-by-value (into {} (map (juxt :value identity)) options)
           current-table (current-table-value tool (:form.field/current-value config-field))]
       [section-card
        [section-label "YOUR CONNECTION"]
        [section-title "Where your data comes from"]
        [section-description "Choose which connection and table to show entries from."]
        [connection-row
         [c/SelectRoot
          {:value (str (:connection/uuid current-conn))
           :onValueChange (on-connection-change {:connections connections
                                                 :set-connection! set-connection!
                                                 :set-config! set-config!})}
          [c/SelectTrigger {:placeholder "Select a connection..."}]
          [c/SelectContent
           (for [{:connection/keys [uuid description type]} connections]
             ^{:key (str uuid)}
             [c/SelectItem {:value (str uuid)}
              [c/Flex {:align "center" :gap "2"}
               ;; Wrapper needed because some icons (e.g. notion) use a dynamic
               ;; viewBox that clips when :size is overridden
               (when-let [icon (get common/tool->icon type)]
                 [:div {:style {:width "18px" :height "18px" :flex-shrink "0"}}
                  [icon]])
               description]])]]
         [manage-link
          {:href (routing/href :connections/table)}
          "Manage connections"]]
        (if tables-loading?
          [c/Flex {:align "center" :gap "2" :py "2"}
           [spinners/pulse-dots]
           [c/Text {:size "2" :color "gray"} "Loading..."]]
          (when (seq options)
            [:<>
             [field-label "Which table to use"]
             [c/SelectRoot
              (cond-> {:onValueChange (on-table-change {:tool tool
                                                        :set-config! set-config!
                                                        :options-by-value options-by-value
                                                        :tables-data tables-data})}
                current-table (assoc :value current-table))
              [c/SelectTrigger {:placeholder "Select a table..."}]
              [c/SelectContent
               (for [{:keys [value label]} options]
                 ^{:key value}
                 [c/SelectItem {:value (str value)} label])]]
             [field-hint "This is the table in your connected tool that holds the records you want to see."]]))])))

;; ---------------------------------------------------------------------------
;; Match settings section
;; ---------------------------------------------------------------------------

#?(:cljs
   (defn match-settings-section
     [mini-app {:keys [connection-field config-field]}]
     (let [current-config (:form.field/current-value config-field)
           set-config! (:form.field/set-value! config-field)
           current-conn (:form.field/current-value connection-field)
           tool (or (:connection/type current-conn) (:mini-app/tool mini-app))
           conn-uuid (:connection/uuid current-conn)
           tables-data @(<s [::tables conn-uuid])
           tables-loading? (= :start @(<s [:fetch/state [::tables conn-uuid]]))
           fields (available-fields tool tables-data current-config)
           selected (current-match-fields tool current-config)
           selected-ids (set (map :id selected))
           unselected (remove #(contains? selected-ids (:id %)) fields)]
       [section-card
        [section-label "MATCH SETTINGS"]
        [section-title "How Humble finds your records"]
        [section-description
         "Choose which columns Humble should use to match a record when you\u2019re browsing."]
        (cond
          tables-loading?
          [c/Flex {:align "center" :gap "2" :py "2"}
           [spinners/pulse-dots]
           [c/Text {:size "2" :color "gray"} "Loading..."]]

          (not (seq fields))
          [c/Text {:size "2" :color "gray"} "Select a connection and table above to configure match settings."]

          :else
          [:<>
           [info-callout
            [icons/outlined-info]
            [:span.text
             "For example, select \u201CLinkedIn URL\u201D, \u201CWebsite\u201D and \u201CEmail\u201D and Humble will try each one until it finds a match."]]
           [field-label "Which columns identify a record"]
           (when (seq selected)
             [match-chips-row
              (for [{:keys [id name]} selected]
                ^{:key id}
                [match-chip
                 name
                 [:button {:on-click #(set-config! (remove-match-field tool current-config id))}
                  [icons/outlined-close]]])])
           (when (seq unselected)
             [dashed-select-wrapper
              (let [fields-by-str-id (into {} (map (fn [f] [(str (:id f)) f])) unselected)]
                [c/SelectRoot
                 {:value ""
                  :onValueChange (fn [str-id]
                                   (when-let [field (get fields-by-str-id str-id)]
                                     (set-config! (add-match-field tool current-config field))))}
                 [c/SelectTrigger {:placeholder "+ Add another column"}]
                 [c/SelectContent
                  (for [{:keys [id name]} unselected]
                    ^{:key (str id)}
                    [c/SelectItem {:value (str id)} name])]])])
           [field-hint "Humble checks each selected column in order. The first match it finds is shown in the extension."]])])))

;; ---------------------------------------------------------------------------
;; Fields section
;; ---------------------------------------------------------------------------

#?(:cljs
   (defn fields-section
     [mini-app {:keys [connection-field config-field]}]
     (let [current-config (:form.field/current-value config-field)
           set-config! (:form.field/set-value! config-field)
           current-conn (:form.field/current-value connection-field)
           tool (or (:connection/type current-conn) (:mini-app/tool mini-app))
           conn-uuid (:connection/uuid current-conn)
           tables-data @(<s [::tables conn-uuid])
           tables-loading? (= :start @(<s [:fetch/state [::tables conn-uuid]]))
           all-fields (available-fields tool tables-data current-config)
           visible-ids (when (seq all-fields)
                         (selected-field-ids tool current-config all-fields))
           hidden-count (when (seq all-fields)
                          (count (remove #(contains? visible-ids (:id %)) all-fields)))]
       [section-card
        [section-label "FIELDS"]
        [section-title "Choose which fields to show"]
        [section-description "All fields are visible by default. Hide any you don\u2019t need."]
        (cond
          tables-loading?
          [c/Flex {:align "center" :gap "2" :py "2"}
           [spinners/pulse-dots]
           [c/Text {:size "2" :color "gray"} "Loading..."]]

          (not (seq all-fields))
          [c/Text {:size "2" :color "gray"} "Select a connection and table above to configure fields."]

          :else
          [:<>
           (when (pos? hidden-count)
             [c/Text {:size "1" :color "gray" :mb "2"}
              (str (count all-fields) " fields \u00B7 " hidden-count " hidden")])
           [c/TableRoot {:size "2"}
            [c/TableHeader
             [c/TableRow
              [c/TableColumnHeaderCell "Field"]
              [c/TableColumnHeaderCell {:style {:text-align "right"}} "Hide"]]]
            [c/TableBody
             (for [{:keys [id name]} all-fields]
               (let [hidden? (not (contains? visible-ids id))]
                 ^{:key id}
                 [c/TableRow
                  [c/TableCell {:style (when hidden? {:opacity "0.4"})} name]
                  [c/TableCell {:style {:text-align "right"}}
                   [c/Switch
                    {:size "1"
                     :checked hidden?
                     :on-checked-change
                     (fn [hide?]
                       (let [new-ids (if hide?
                                       (disj visible-ids id)
                                       (conj visible-ids id))]
                         (set-config! (set-selected-fields tool current-config all-fields new-ids))))}]]]))]]])])))

;; ---------------------------------------------------------------------------
;; Danger zone
;; ---------------------------------------------------------------------------

#?(:cljs
   (defn danger-zone-section
     [mini-app]
     [danger-zone-card
      [danger-zone-header
       [:div.left
        [danger-label "DANGER ZONE"]
        [section-title "Remove this mini-app"]
        [section-description
         "This deletes the mini-app and all its settings for everyone. It can\u2019t be undone."]]
       [:div.action
        [danger-link
         {:on-click (fn []
                      (when (js/confirm "Are you sure you want to delete this mini-app? This can't be undone.")
                        (>e [:resolve [(list 'mini-app/delete {:mini-app/uuid (:mini-app/uuid mini-app)})]
                             {:on-success-fx
                              [[:dispatch [:toast/success {:text "Mini-app deleted"}]]
                               [:dispatch [:routing/navigate [:admin-ui/setup]]]
                               [:browser-ext/notify-mini-apps-changed {:mini-app/uuids [(:mini-app/uuid mini-app)] :change :deleted}]]}])))}
         "Remove mini-app"]]]]))

;; ---------------------------------------------------------------------------
;; Page
;; ---------------------------------------------------------------------------

#?(:cljs
   (defn- on-submit-update
     [mini-app value]
     (let [fields-update (select-keys value [:mini-app/title
                                             :mini-app/description
                                             :mini-app/config])]
       (>e [:resolve [(list 'mini-app/update
                            {:mini-app/uuid (:mini-app/uuid value)
                             :mini-app/fields-update fields-update})]
            {:on-success-fx
             [[:dispatch [:form/submitted ::form]]
              [:dispatch [:toast/success {:text "Changes saved"}]]
              [:dispatch [:entity/resolve {:mini-app/uuid (:mini-app/uuid mini-app)}]]
              [:browser-ext/notify-mini-apps-changed {:mini-app/uuids [(:mini-app/uuid mini-app)] :change :updated}]]}]))))

#?(:cljs
   (defevent-fx ::on-create-success
     [_ mini-app-uuid]
     {:fx [[:dispatch [:toast/success {:text "Mini-app created"}]]
           [:dispatch [:routing/navigate [:admin-ui/mini-app-edit {:mini-app/uuid mini-app-uuid}]]]]}))

(def ^:private connection-type->tool
  "Maps connection type to mini-app tool type.
   Most are 1:1 except :database connections become :jdbc mini-apps."
  {:database :jdbc})

#?(:cljs
   (defevent-fx ::on-submit-create
     [{:keys [db]} value]
     (let [mini-app-uuid (:mini-app/uuid value)
           conn (:mini-app/connection value)
           conn-type (:connection/type conn)
           tool (get connection-type->tool conn-type conn-type)
           config (or (:mini-app/config value) {})
           conn-uuid (:connection/uuid conn)
           tables-data (get-in db [::tables conn-uuid])
           config (ensure-selected-fields tool tables-data config)
           ;; For hubspot, merge portal-id and contact-properties from loaded data
           config (cond-> config
                    (= tool :hubspot)
                    (merge (select-keys tables-data [:hubspot/portal-id
                                                     :hubspot/contact-properties])))
           body (cond-> {:mini-app/uuid mini-app-uuid
                         :mini-app/title (:mini-app/title value)
                         :mini-app/tool tool
                         :mini-app/config config
                         :mini-app/active? true}
                  conn (assoc :mini-app/connection (:connection/uuid conn)))]
       {:fetch {:url "/mini-apps/v1"
                :method :put
                :body body
                :on-success-fx [[:dispatch [::on-create-success mini-app-uuid]]
                                [:browser-ext/notify-mini-apps-changed {:mini-app/uuids [mini-app-uuid] :change :created}]]
                :on-error-fx [[:dispatch [:toast/error {:text "Failed to create mini-app"}]]]}})))

#?(:cljs
   (defn mini-app-form
     [{:keys [mini-app create?]}]
     (let [entity (or mini-app {})]
       [form/component
        {:id ::form
         :schema [:map
                  [:mini-app/uuid :uuid]
                  [:mini-app/title {:placeholder "Mini-app name"} :string]
                  [:mini-app/description {:optional true :placeholder "Optional description"} [:maybe :string]]
                  [:mini-app/connection {:optional true} :any]
                  [:mini-app/config {:optional true} :any]]
         :initial-value (if create?
                          {:mini-app/uuid (random-uuid)}
                          (select-keys mini-app [:mini-app/uuid
                                                 :mini-app/title
                                                 :mini-app/description
                                                 :mini-app/connection
                                                 :mini-app/config]))
         :on-submit (if create?
                      #(>e [::on-submit-create %])
                      (partial on-submit-update mini-app))
         :render (fn [{{:mini-app/keys [title description connection config]} :form/fields
                       :form/keys [on-submit valid? submitting?]}]
                   [:<>
                    [section-card
                     [section-label "DETAILS"]
                     [section-title "Name & description"]
                     [c/Box {:mt "2"}
                      [field-label "Title"]
                      [input/field title]]
                     [c/Box {:mt "2"}
                      [field-label "Description"]
                      [input/textarea description]]]
                    [c/Box {:mt "2"}
                     [connection-section entity
                      {:connection-field connection
                       :config-field config}]]
                    [c/Box {:mt "2"}
                     [match-settings-section entity
                      {:connection-field connection
                       :config-field config}]]
                    [c/Box {:mt "2"}
                     [fields-section entity
                      {:connection-field connection
                       :config-field config}]]
                    [c/Box {:mt "2"}
                     [c/Button
                      {:disabled (or (not valid?) submitting?)
                       :on-click on-submit}
                      (if create? "Create mini-app" "Save changes")]]])}])))

#?(:cljs
   (defn page
     [route-match]
     (let [mini-app-uuid (-> @route-match :parameters :path :mini-app/uuid)
           request-id [::load mini-app-uuid]
           fetch-state @(<s [:fetch/state request-id])
           mini-app @(<s [:entity {:mini-app/uuid mini-app-uuid}])]
       (cond
         (= fetch-state :start)
         [c/Flex {:p "8" :justify "center" :align "center"}
          [spinners/pulse-dots]]

         (= fetch-state :error)
         [c/Flex {:p "8"}
          [:div "Failed to load mini-app"]]

         (some? mini-app)
         [layout/page
          [layout/breadcrumbs {:breadcrumbs [(:mini-app/title mini-app)]}]
          [layout/content
           [mini-app-header mini-app]
           (when (sharing/can-edit? mini-app)
             [:<>
              [mini-app-form {:mini-app mini-app}]
              [c/Box {:mt "4"}
               [section-card
                [section-title "Sharing"]
                [c/Box {:mt "2"}
                 [sharing.components/permissions-table mini-app]]]]
              [c/Box {:mt "4"}
               [danger-zone-section mini-app]]])]]))))

#?(:cljs
   (defn create-page
     [_route-match]
     [layout/page
      [layout/breadcrumbs {:breadcrumbs ["New mini-app"]}]
      [layout/content
       [page-header
        [header-top
         [icon-container [icons/outlined-apps]]
         [title-text "New mini-app"]]]
       [mini-app-form {:create? true}]]]))
